import React from "react";
import { Container, Title, Description } from "./EmptyState.styled";
import { Icon } from "../../../../icon";

const EmptyState = ({ title, description }) => {
  return (
    <Container>
      <Title>{title}</Title>
      <Description>{description}</Description>
      <Icon name="noDataAvailable" />
    </Container>
  );
};

export default EmptyState;
